import { defineComponent, inject } from "vue";
import { isNullOrEmpty } from "../../../skyward.base.extensions";
import { OptionalVueProp } from "../../core/vueHelpers";
import { classNames } from "../classes";
import { labeledDataListOptionsKey } from "./LabeledDataList";

export interface LabelPartProps
{
    html?: string;
}

const LabelPart = defineComponent<LabelPartProps>({
    name: "LabelPart",
    props:
    {
        html: OptionalVueProp(String)
    },
    setup(props, { slots })
    {
        const listOptions = inject(labeledDataListOptionsKey, {});

        return () =>
        {
            const classes =
            {
                [classNames.labeledDataPart]: true,
                [classNames.labeledDataLabel]: true,
                [classNames.decorativeLabel]: true,
                [classNames.visualLabel]: true,
                [classNames.selectorLabel]: listOptions.isForSelector,
                [classNames.legendOptionLabel]: listOptions.isForLegend,
                [classNames.titleMargin]: listOptions.alignLabels
            };

            if (!isNullOrEmpty(props.html))
            {
                return (
                    <dt class={classes} innerHTML={props.html} />
                );
            }

            return (
                <dt class={classes}>{slots.default?.()}</dt>
            );
        };
    }
});

export default LabelPart;
